import * as React from "react";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { Dreams } from "source/app/presentation/MainPanel/Dreams/Dreams";
import { GetDreamAttributeTextColor } from "../../DreamAttributeIcon/AttributeMap/AttributeMap";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function AverageProblemDifficulty({ dreams }: { dreams: Dreams }) {
    const problemAttribute = EDA.problem;

    const problemDreams = dreams.state.dreamsdata.filter((dream) =>
        dream.attributes.includes(EDA[problemAttribute])
    );

    if (problemDreams.length === 0) {
        return null;
    }

    const problemDifficulties = problemDreams.map((dream) => dream.difficulty);

    const average = problemDifficulties.length
        ? problemDifficulties.reduce((a, b) => a + b) /
          problemDifficulties.length
        : 0;

    const result = average.toFixed(1);

    const textColor = GetDreamAttributeTextColor(problemAttribute);

    // console.log(
    //     `[Dreams] ${problemDreams.length} problem dreams found with average of ${result} difficulty`
    // );

    return (
        <span
            className={StyleClassAuto({
                color: textColor,
                position: `relative`,
                right: `3px`,
            })}
        >
            ({result})
        </span>
    );
}
